import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import translate from "../../../i18n/translate";
import { getVocabularyContents } from "../../../redux/actions/vocabularyCenterAction";
import CircularProgress from "@material-ui/core/CircularProgress";
import TopicListBanner from "./TopicListBanner/TopicListBanner";
import { Breadcrumbs, Typography } from "@material-ui/core";
import { removeSpecialCharacters } from "./VocabularyCenterPOCUtils";
import { useAddWordListDialog } from "./useAddWordList";
import DialogView from "./DialogContents";
import { getRandomNumber } from "../../shared/utils/sharedUtils";
import { AddCircleIcon, ArrowForwardIosIcon, NavigateNextIcon } from "../../common/icon";

const TopicList = () => {
  const navigate = useNavigate();
  const prams = useParams();
  const dispatch = useDispatch();
  const { peopleInformation, common, vocabularyContents } = useSelector((state: any) => state);
  const [selectedTopic, setSelectedTopic] = useState<any>(null);
  const [searchText, setSearchText] = useState<string>("");
  // Add a new state variable for the filtered list
  const [filteredTopic, setFilteredTopic] = useState<any>(null);
  const addWordListDialog = useAddWordListDialog();

  useEffect(() => {
    if (
      vocabularyContents?.headerLevelContents &&
      typeof vocabularyContents.headerLevelContents === "object" &&
      Object.keys(vocabularyContents.headerLevelContents).length > 0
    ) {
      const selectedTopicListData = vocabularyContents.topicsListData.find((topic: any) => topic.topic === prams.topic);
      setSelectedTopic(selectedTopicListData);
    } else if (peopleInformation?.data && common?.lgId) {
      const { token, accountId } = peopleInformation.data.getpeopleInformation;
      dispatch(getVocabularyContents(common.lgId, token, parseInt(accountId, 10)));
    }
  }, [vocabularyContents, peopleInformation]);

  const handleSearch = (e: any) => {};

  useEffect(() => {
    if (searchText.length > 0) {
      const filteredListDetails = selectedTopic?.listDetails?.filter((item: any) =>
        item.wordlist.toLowerCase().includes(searchText.toLowerCase()),
      );
      if (filteredListDetails) {
        setFilteredTopic((prevValue: any) => {
          return { ...prevValue, listDetails: filteredListDetails };
        });
      }
    } else {
      setFilteredTopic(selectedTopic);
    }
  }, [searchText, selectedTopic]);

  return (
    <div className="new-vocabulary-center-container" data-testid="topicList">
      <TopicListBanner
        topicName={removeSpecialCharacters(prams.topic)}
        searchText={searchText}
        setSearchText={setSearchText}
        changeClassName={"change-view"}
        showWordLists={true}
        handleSearch={handleSearch}
        isNotVocabCenterPage={true}
        searchOnly={true}
      />

      <div className="vocabulary-center-wordlist-container">
        {vocabularyContents.isWordAddingToList ||
        vocabularyContents.isWordListCreating ||
        vocabularyContents.isWordDeleting ||
        vocabularyContents.isWordListDeleting ||
        selectedTopic == null ? (
          <div className="loader-wrapper">
            <CircularProgress color="primary" className="circularLoader" size={100} />
          </div>
        ) : (
          <>
            <div className="back-container">
              <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb">
                <button
                  className="remove-button-default-style"
                  color="inherit"
                  data-testid="Vocabulary-Center"
                  onClick={() => navigate("/vocabularycenter")}
                >
                  Vocabulary Center
                </button>
                {<Typography color="textPrimary"> {removeSpecialCharacters(prams.topic)}</Typography>}
              </Breadcrumbs>
              {prams.topic == "userWordlists" && (
                <div className=" add-wordlist-box">
                  <button
                    className="remove-button-default-style add-wordlist-box-wrapper"
                    onClick={() => addWordListDialog.openDialog()}
                  >
                    <AddCircleIcon className="add-wordlist-icon" />
                    <p className="add-wordlist-label">Add wordlist</p>
                  </button>
                </div>
              )}
            </div>
            <div className="topic-list-details-container">
              {filteredTopic?.listDetails?.length > 0 ? (
                filteredTopic.listDetails.map((listDetail: any, subIndex: number) => (
                  <button
                    className="remove-button-default-style topic-list-details"
                    data-testid={`topic-list-details${subIndex}`}
                    key={getRandomNumber(subIndex)}
                    onClick={() => {
                      navigate(`/vocabularycenter/${prams.topic}/${listDetail.listId}`);
                    }}
                  >
                    <p className="topic-list-label">
                      {listDetail.wordlist} ({listDetail.wordCount})
                    </p>
                    <ArrowForwardIosIcon className="topic-list-arrow-action" />
                  </button>
                ))
              ) : (
                <div className="no-wordlist-container">
                  <p className="no-wordlist-message">
                    {translate("vocab_center_no_wordlist_message", {
                      wordListName: removeSpecialCharacters(prams.topic),
                    })}
                  </p>
                </div>
              )}
            </div>
          </>
        )}
        <DialogView
          open={addWordListDialog.isOpen}
          handleClose={addWordListDialog.closeDialog}
          dialogContainerClassNameValue="vocabulary-show-add-wordlist-popup"
          dialogContentsClassName="vocabulary-show-add-wordlist-contents"
          dialogBody={addWordListDialog.getAddWordList()}
        />
      </div>
    </div>
  );
};

export default TopicList;
